import { render, staticRenderFns } from "./UserAccessRights.vue?vue&type=template&id=2cce7c6a&scoped=true&"
import script from "./UserAccessRights.vue?vue&type=script&lang=ts&"
export * from "./UserAccessRights.vue?vue&type=script&lang=ts&"
import style0 from "./UserAccessRights.vue?vue&type=style&index=0&id=2cce7c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cce7c6a",
  null
  
)

export default component.exports